export default function domainNameToSentryFilterRegex(
    domainName: string,
): RegExp {
    return new RegExp(
        'https?:\\/\\/(.*)?' + domainName.trim().replace('.', '\\.'),
        'i',
    );
}
